import { abandonPendingLocationRequests } from "@/domain/destination/request-current-location"
import { clearAllDestinationCoordinates } from "@/domain/destination/destination-coordinates.store"
import { resetSavedAddressDestinationResolver } from "@/domain/destination/resolve-saved-address-destination"
import {
  abandonPendingServiceabilityChecks,
  resetServiceabilityState,
} from "@/domain/serviceability/serviceability-state.store"

/**
 * Tenant/session teardown for destination pins, in-flight geolocation,
 * and advisory serviceability. Abandon first so late callbacks/HTTP cannot resurrect.
 */
export function clearDestinationSession(): void {
  abandonPendingLocationRequests()
  abandonPendingServiceabilityChecks()
  clearAllDestinationCoordinates()
  resetSavedAddressDestinationResolver()
  resetServiceabilityState()
}
